module.exports = __webpack_public_path__ + "img/parliament-1.132c8bcf.jpg";